import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function SectorHero({ kicker, title, blurb, image, tags = [] }) {
  return (
    <section data-testid="sector-hero" className="relative overflow-hidden bg-[#1F2937] text-white">
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1F2937] via-[#1F2937]/70 to-transparent" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 md:py-40">
        <div className="text-xs font-semibold tracking-[0.24em] text-[#10B981] uppercase mb-5 fade-up">
          {kicker}
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl text-balance fade-up" style={{ animationDelay: "0.05s" }}>
          {title}
        </h1>
        <p className="mt-6 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed fade-up" style={{ animationDelay: "0.1s" }}>
          {blurb}
        </p>
        {tags?.length > 0 && (
          <div className="mt-8 flex flex-wrap gap-2 fade-up" style={{ animationDelay: "0.15s" }}>
            {tags.map((t) => (
              <span key={t} className="text-xs px-3 py-1.5 rounded-full bg-white/10 backdrop-blur border border-white/15">
                {t}
              </span>
            ))}
          </div>
        )}
        <div className="mt-10 flex flex-wrap gap-3 fade-up" style={{ animationDelay: "0.2s" }}>
          <Link
            to="/eligibility"
            data-testid="sector-hero-cta-eligibility"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-lg bg-[#0055A4] hover:bg-[#003D7A] text-white font-semibold shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5"
          >
            Vérifier mon éligibilité <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/contact"
            data-testid="sector-hero-cta-contact"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-lg border-2 border-white/40 hover:bg-white hover:text-[#1F2937] text-white font-semibold transition-all"
          >
            Parler à un expert
          </Link>
        </div>
      </div>
    </section>
  );
}
